// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"712a2efa","590":"b7855e28","873":"79d109cd","982":"45b1d301","988":"1d8eeda1"}[chunkId] + ".chunk.js";
};